import React from 'react';

const withForwardedRef = (Component) =>
    React.forwardRef((props, ref) => {
        return <Component {...props} forwardedRef={ref} />;
    });

export default withForwardedRef;
